import { data_center_eu, device_id_key } from 'eco-design-micro/EcoStat/config';
import { getCookie } from 'eco-design-micro/utils-base/getCookie';
import { getPreviewIdA1 } from 'eco-design-micro/utils-base/getPreviewIdA1';
import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { getIsPadWidth } from '@elem/utils/devices';

interface WidgetsItemQuestionnaireIprops {
    iconUrl: string;
    show?: () => void;
    hide?: () => void;
    effectUser: string;
    hasContinue: boolean;
}
const NEXT_PUBLIC_BH_HOST = process.env.NEXT_PUBLIC_BH_HOST;
const NEXT_PUBLIC_BH_HOST_NA = process.env.NEXT_PUBLIC_BH_HOST_NA;
export default function WidgetsItemQuestionnaire({ iconUrl, show, hide, effectUser, hasContinue }: WidgetsItemQuestionnaireIprops) {
    const { locale = 'us' } = getLocal();
    const [openA, setOpenA] = useState(false);
    const openKeyQuestionnaireAA1 = 'openKeyQuestionnaireAA1';
    const stat_node_api = data_center_eu.includes(locale) ? NEXT_PUBLIC_BH_HOST : NEXT_PUBLIC_BH_HOST_NA;
    const isMobile = getIsPadWidth();
    useEffect(() => {
        const initHandleA = async () => {
            const headers: any = {};
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';
            const device_id = getCookie(device_id_key);
            const preview_id = getPreviewIdA1();
            const resA = await fetch(`${stat_node_api}/gtm/common-statistics/web/find-user-exist-by-device-id-time-a1`, {
                method: 'post',
                body: JSON.stringify({
                    device_id,
                    preview_id,
                }),
                headers: headers,
            });
            const dataA = await resA.json();
            const dataB = dataA?.data || false; //true为之前访问过
            localStorage.setItem(openKeyQuestionnaireAA1, dataB ? '1' : '0'); //1为有记录;0为无访问记录
            setOpenA(!dataB);
        };
        const initHandleB = async () => {
            const openKeyQuestionnaireVal = localStorage.getItem(openKeyQuestionnaireAA1);
            if (!openKeyQuestionnaireVal) {
                //没有进行过接口请求
                initHandleA();
            } else if (openKeyQuestionnaireVal === '0') {
                //无访问记录
                setOpenA(true);
            }
        };
        if (effectUser === 'new') {
            initHandleB();
        } else {
            setOpenA(true);
        }
    }, []);
    if (!openA) {
        return null;
    }
    return (
        <section
            className={styles.WidgetsItemQuestionnaire}
            onClick={isMobile ? show : undefined}
            onPointerEnter={isMobile ? undefined : show}
            onPointerLeave={isMobile ? undefined : hide}
            id="WIDGET_Questionnaire"
        >
            <div className="icon-box WidgetsItem-icon">
                <EcoImg className="icon-img" pc={iconUrl}></EcoImg>
            </div>
        </section>
    );
}
